<template>
  <div class="rc-page">
      <!-- 导航栏 / 面包屑 --> 
    <div>
        <nav class="breadcrumb-nav">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <router-link to="/product">产品中心</router-link>
            <span class="separator">/</span>
            <span class="current">风控合规数字化平台</span> 
        </nav>
    </div>

    <!-- 英雄区（产品Banner） -->
    <section class="rc-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>风控合规数字化平台<br><span style="color: var(--rc-accent-blue);">Risk &amp; Compliance Digital Suite</span></h1>
        <p class="rc-subhead">以数据为底座 · 以模型为核心 · 以AI为引擎，构建覆盖"风险识别—合规校验—审计监督—整改闭环"的一体化数字治理平台，实现风险前置预警与智能决策支持。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="rc-btn rc-btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="rc-btn rc-btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="rc-keyword-cloud">
        <h2 class="rc-keyword-tag highlight">企业风控系统</h2>
        <h2 class="rc-keyword-tag">合规管理系统</h2>
        <h2 class="rc-keyword-tag">内控合规平台</h2>
        <h2 class="rc-keyword-tag">风险预警系统</h2>
        <h2 class="rc-keyword-tag">智能风控</h2>
        <h2 class="rc-keyword-tag">AI合规审查</h2>
        <h2 class="rc-keyword-tag">风险管理数字化</h2>
        <h2 class="rc-keyword-tag">责任穿透</h2>
        <h2 class="rc-keyword-tag">反舞弊系统</h2>
        <h2 class="rc-keyword-tag">AI智能体</h2>
      </div>
    </section>

    <!-- 背景与痛点 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 2026监管趋势与企业核心痛点</h2>
      <div class="rc-card-grid-3">
        <div class="rc-feature-card">
          <h3>风险识别滞后</h3>
          <p>依赖人工经验判断，缺乏量化风险模型，预警机制不足，风险往往事后才发现。</p>
        </div>
        <div class="rc-feature-card">
          <h3>合规管理碎片化</h3>
          <p>制度多但执行弱，合规检查人工化，整改追踪不闭环，合规成本高。</p>
        </div>
        <div class="rc-feature-card">
          <h3>审计与风控脱节</h3>
          <p>审计发现未反哺风险模型，风险未驱动审计计划，数据未打通，协同效率低。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">穿透式监管、强内控、严合规成为主旋律，企业亟需构建体系化、智能化、一体化的风控合规平台。</p>
    </section>

    <!-- 产品定位 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 产品定位</h2>
      <div class="rc-arch-card" style="background: #F5F5F5; color: #EAF0FB; box-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);">
        <h2 style="color: #2B2F3A; margin-bottom: 20px;">企业级风控合规数字中枢</h2>
        <p style="font-size: 1.2rem;">数据驱动、模型驱动、AI驱动，实现风险可量化、合规可验证、责任可穿透、过程可追溯，构建企业风险治理与合规管控的"最强大脑"。</p>
      </div>
    </section>

    <!-- 核心功能模块（六个卡片，带颜色标识） -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 六大核心能力</h2>
      <div class="rc-card-grid-6">
        <!-- 模块1：企业风险矩阵与评分模型 -->
        <div class="rc-feature-card">
          <h3>企业风险矩阵与评分模型</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风险分类分级管理</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 概率与影响度测算</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 自动评分与排名</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风险趋势预测</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">风险矩阵</span><span class="rc-keyword-tag">风险热力图</span></div>
        </div>

        <!-- 模块2：合规规则引擎与制度数字化 -->
        <div class="rc-feature-card">
          <h3>合规规则引擎与制度数字化</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 制度条款结构化</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 合规规则配置化</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 自动规则校验</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 合规检查自动生成</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">规则引擎</span><span class="rc-keyword-tag">制度数字化</span></div>
        </div>

        <!-- 模块3：AI合同与凭证审查系统 -->
        <div class="rc-feature-card">
          <h3>AI合同与凭证审查系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 自动阅读合同</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 识别风险条款</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 凭证异常检测</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 自动生成合规报告</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">合同审查</span><span class="rc-keyword-tag">NLP</span></div>
        </div>

        <!-- 模块4：异常交易与反舞弊系统 -->
        <div class="rc-feature-card">
          <h3>异常交易与反舞弊系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 关联交易识别</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 资金异常路径分析</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 围标串标识别</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 反舞弊风险预警</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">反舞弊</span><span class="rc-keyword-tag">图谱分析</span></div>
        </div>

        <!-- 模块5：AI多智能体协同系统 -->
        <div class="rc-feature-card">
          <h3>AI多智能体协同系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风控智能体: 风险报告</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 合规智能体: 合规建议</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 审计智能体: 生成底稿</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 报告生成智能体</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">AI智能体</span><span class="rc-keyword-tag">多智能体</span></div>
        </div>

        <!-- 模块6：风险责任穿透系统 -->
        <div class="rc-feature-card">
          <h3>风险责任穿透系统</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风险事件映射岗位</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 干部履职风险画像</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 问责路径分析</li>
            <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风险经验沉淀</li>
          </ul>
          <div style="margin-top: 16px;"><span class="rc-keyword-tag">责任穿透</span><span class="rc-keyword-tag">干部画像</span></div>
        </div>
      </div>
    </section>

    <!-- 技术架构亮点 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 技术架构亮点</h2>
      <div class="rc-arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="rc-compliance-badge">企业数据中台</span>
          <span class="rc-compliance-badge">风险数据集市</span>
          <span class="rc-compliance-badge">图数据库</span>
          <span class="rc-compliance-badge">大语言模型</span>
          <span class="rc-compliance-badge">实时预警</span>
          <span class="rc-compliance-badge">可视化驾驶舱</span>
        </div>
        <div class="rc-arch-grid">
          <div class="rc-arch-item">
            <h3>数据中台与风险集市</h3>
            <p>整合多源数据，构建统一风险数据视图，支持快速建模与指标计算。</p>
          </div>
          <div class="rc-arch-item">
            <h3>图数据库与知识图谱</h3>
            <p>构建企业关系图谱，支持股权穿透、资金路径、关联交易深度挖掘。</p>
          </div>
          <div class="rc-arch-item">
            <h3>大模型语义引擎</h3>
            <p>基于LLM的合同解析、条款识别、智能问答，提升自动化水平。</p>
          </div>
        </div>
      </div>
    </section>




    <!-- 典型应用场景 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 典型应用场景</h2>
      <div class="rc-card-grid-4">
        <div class="rc-feature-card">
          <h3>国资集团企业</h3>
          <p>投资风险管控、干部履职监督、穿透式监管。</p>
        </div>
        <div class="rc-feature-card">
          <h3>金融机构</h3>
          <p>风险合规一体化、反洗钱与异常交易监控。</p>
        </div>
        <div class="rc-feature-card">
          <h3>能源与制造企业</h3>
          <p>供应链风险管理、合同与资金合规管理。</p>
        </div>
        <div class="rc-feature-card">
          <h3>政府监管单位</h3>
          <p>穿透式监管、风险预警与责任追溯。</p>
        </div>
      </div>
    </section>

    <!-- 产品核心优势 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 产品核心优势</h2>
      <div class="rc-card-grid-4">
        <div class="rc-feature-card">
          <h3>一体化闭环管理</h3>
          <p>风险识别 → 合规校验 → 审计监督 → 整改闭环 → 模型优化，全流程打通。</p>
        </div>
        <div class="rc-feature-card">
          <h3>AI驱动风险前置</h3>
          <p>AI实时扫描，定位具体风险，风险管理从事后转向事前预警，降低风险发生概率。</p>
        </div>
        <div class="rc-feature-card">
          <h3>数据驱动精准治理</h3>
          <p>基于数据驱动的风险管理，全面覆盖，全面标准化，减少人工依赖，提高覆盖率与准确率。</p>
        </div>
        <div class="rc-feature-card">
          <h3>支撑数字治理升级</h3>
          <p>纳入AI、Agent、数据，构建智能化、标准化、可持续优化的风控合规体系。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 关键成果与价值</h2>
      <div class="rc-stat-grid">
        <div class="rc-stat-card">
          <div class="rc-stat-number">60%</div>
          <p>风险识别效率提升</p>
        </div>
        <div class="rc-stat-card">
          <div class="rc-stat-number">50%</div>
          <p>合规检查成本降低</p>
        </div>
        <div class="rc-stat-card">
          <div class="rc-stat-number">实时</div>
          <p>风险预警</p>
        </div>
        <div class="rc-stat-card">
          <div class="rc-stat-number">100%</div>
          <p>责任可追溯</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 风险量化模型覆盖全部业务单元</li>
          <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 合规规则自动校验，减少人工干预</li>
          <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 审计线索与风险模型双向反哺</li>
          <li class="rc-list-item"><i class="fa-regular fa-circle-check"></i> 干部风险画像支撑经责审计</li>
        </ul>
      </div>
    </section>

    <!-- 适用客户群体 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 适用客户群体</h2>
      <div class="rc-client-tags">
        <span class="rc-client-tag">央企集团</span>
        <span class="rc-client-tag">地方国企</span>
        <span class="rc-client-tag">金融机构</span>
        <span class="rc-client-tag">能源企业</span>
        <span class="rc-client-tag">制造企业</span>
        <span class="rc-client-tag">政府监管单位</span>
        <span class="rc-client-tag">审计机关</span>
        <span class="rc-client-tag">纪检监察</span>
      </div>
    </section>

    <!-- 相关产品推荐 -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 相关产品与平台</h2>
      <div class="rc-related-grid">
        <router-link to="/product/smart-audit-risk" class="rc-related-card">
          <h3>智慧审计平台</h3>
          <p>覆盖非现场审计、经责审计、干部画像、风险矩阵等八大领域，助力审计风控合规数字化转型。</p>
        </router-link>
        <router-link to="/product/penetrating-supervision" class="rc-related-card">
          <h3>穿透式监管平台</h3>
          <p>全链条风险穿透与责任追溯，实现监管全覆盖、问题可追溯、风险可量化。</p>
        </router-link>
        <router-link to="/product/ai-agent" class="rc-related-card">
          <h3>AI智能体平台</h3>
          <p>多智能体协同，数据分析与治理智能体融合，实现自动分析与智能决策。</p>
        </router-link>
        <router-link to="/product/data-governance-platform" class="rc-related-card">
          <h3>AI驱动风险管理平台</h3>
          <p>风险自动识别及预判，风险分类，风险评定，风险跟踪管理，风险处置及风险成果最大化。</p>
        </router-link>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="rc-container">
      <h2><i class="fa-regular fa-star"></i> 常见问题</h2>
      <div class="rc-faq-list">
        <div class="rc-faq-item">
          <div class="rc-faq-question"><i class="fa-regular fa-message"></i> 平台如何实现风险与合规的一体化？</div>
          <div class="rc-faq-answer">平台内置风险模型与合规规则引擎，风险识别结果自动触发合规校验，审计发现问题反哺风险模型，形成一体化闭环。</div>
        </div>
        <div class="rc-faq-item">
          <div class="rc-faq-question"><i class="fa-regular fa-message"></i> AI智能体如何协同工作？</div>
          <div class="rc-faq-answer">风控、合规、审计、报告四个智能体共享数据底座，通过大模型协同，自动完成风险分析、合规建议、底稿生成、报告撰写等任务。</div>
        </div>
        <div class="rc-faq-item">
          <div class="rc-faq-question"><i class="fa-regular fa-message"></i> 能否与现有ERP、审计系统对接？</div>
          <div class="rc-faq-answer">支持标准API接口，可对接SAP、用友、金蝶、古杉非现场审计平台等，实现数据互通与业务协同。</div>
        </div>
        <div class="rc-faq-item">
          <div class="rc-faq-question"><i class="fa-regular fa-message"></i> 如何保障数据安全？</div>
          <div class="rc-faq-answer">支持私有化部署，符合等保2.0要求，数据加密传输与存储，权限精细化管理。</div>
        </div>
        <div class="rc-faq-item">
          <div class="rc-faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="rc-faq-answer">一般3-4个月完成试点上线，包括风险指标体系梳理、规则配置、系统对接和人员培训。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="rc-container cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建全面风险管理与合规数字化体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>和咨询方向</label>
            <select>
              <option value="">-- 请选择和咨询方向 --</option>
              <option>风险矩阵与风控体系建设</option>
              <option>合规管理数字化转型</option>
              <option>内控与内审一体化</option>
              <option>全面风险管理规划</option>
              <option>AI 风控平台建设</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「风控合规」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'ProductDetailRiskCompliance',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    },
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      this.showQrModal = true
    }
  }
};
</script>

<style scoped>
.rc-page {
  --rc-primary-dark: #1D4E4E;
  --rc-primary-soft: #e9f3f2;
  --rc-accent-gold: #D4AF37;
  --rc-accent-blue: #2A7DE1;
  --rc-gray-light: #f8fafc;
  --rc-gray-border: #e2e8f0;
  --rc-text-dark: #0f2a2a;
  --rc-text-regular: #2d3f4b;
  --rc-white: #ffffff;
  --rc-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: #ffffff;
  color: var(--rc-text-regular);
  font-size: 16px;
  line-height: 1.8;
}

.rc-page *, .rc-page *::before, .rc-page *::after {
  box-sizing: border-box;
}

.rc-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}


.rc-page section {
  padding: 40px 12px;
}

.rc-page h1, .rc-page h2, .rc-page h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--rc-text-dark);
}

.rc-page h1 {
  font-size: 42px;
  line-height: 1.2;
}

.rc-page h2 {
  font-size: 28px;
  margin-bottom: 24px;
}

.rc-page h2 i {
  color: var(--rc-accent-blue);
  margin-right: 8px;
}

.rc-page h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.rc-subhead {
  font-size: 18px;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.rc-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.rc-btn-primary {
  background-color: var(--rc-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.rc-btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.rc-btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--rc-primary-dark);
  color: var(--rc-primary-dark);
}

.rc-btn-outline:hover {
  background-color: var(--rc-primary-dark);
  color: white;
}

.rc-btn-accent {
  background-color: var(--rc-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.rc-btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 导航 */
.rc-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid var(--rc-gray-border);
  background-color: white;
  margin-bottom: 20px;
}

.rc-logo {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--rc-primary-dark);
}

.rc-logo span {
  color: var(--rc-accent-gold);
}

.rc-back-link {
  text-decoration: none;
  color: var(--rc-primary-dark);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--rc-gray-border);
  padding: 8px 16px;
  border-radius: 40px;
  transition: 0.2s;
}

.rc-back-link:hover {
  background-color: var(--rc-primary-soft);
  border-color: var(--rc-primary-dark);
}

/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {
  background: var(--rc-primary-soft);
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: var(--rc-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.rc-card-grid-3, .rc-card-grid-4, .rc-card-grid-6 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.rc-card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.rc-card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.rc-card-grid-6 {
  grid-template-columns: repeat(3, 1fr);
}

.rc-feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--rc-shadow);
  border: 1px solid var(--rc-gray-border);
  transition: transform 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.rc-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.rc-card-icon {
  font-size: 2.5rem;
  color: var(--rc-primary-dark);
  margin-bottom: 20px;
}

.rc-list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.rc-list-item i {
  color: var(--rc-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.rc-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.rc-stat-card {
  background: var(--rc-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.rc-stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--rc-primary-dark);
  margin-bottom: 8px;
}

.rc-client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
  color:#2A7DE1
}

.rc-client-tag {
  background: white;
  border: 1px solid var(--rc-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--rc-text-dark);
}

.rc-case-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: var(--rc-shadow);
}

.rc-case-stats {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--rc-primary-dark);
  margin: 16px 0 8px;
}

/* 技术架构卡片 */
.rc-arch-card {
  background: var(--rc-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.rc-arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.rc-arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.rc-compliance-badge {
  display: inline-block;
  background: var(--rc-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.rc-faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.rc-faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--rc-gray-border);
}

.rc-faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--rc-text-dark);
}

.rc-faq-question i {
  color: var(--rc-accent-gold);
}

.rc-faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.rc-cta-block {
  background: var(--rc-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.rc-cta-block h2 {
  color: white;
}

.rc-cta-block .rc-btn-primary {
  background-color: white;
  color: var(--rc-primary-dark);
  margin: 0 8px;
}

.rc-cta-block .rc-btn-outline {
  border-color: white;
  color: white;
}

.rc-cta-block .rc-btn-outline:hover {
  background-color: white;
  color: var(--rc-primary-dark);
}





.sar-cta-block {
  background: #f8fafc;
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.sar-cta-block .sar-h2 {
  color: #1D4E4E;
}

.sar-cta-block .sar-btn-primary {
  background-color: white;
  color: #1D4E4E;
  margin: 0 8px;
}

.sar-cta-block .sar-btn-outline {
  border-color: white;
  color: white;
}

.sar-cta-block .sar-btn-outline:hover {
  background-color: white;
  color: #1D4E4E;
}




/* 模态框 */
.rc-modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.rc-modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.rc-close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.rc-modal h3 {
  margin-bottom: 24px;
}

.rc-form-group {
  margin-bottom: 20px;
}

.rc-form-group input, .rc-form-group textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--rc-gray-border);
  border-radius: 30px;
  font-size: 1rem;
}

.rc-modal .rc-btn {
  width: 100%;
  margin-top: 10px;
}

.rc-footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--rc-gray-border);
  margin-top: 40px;
}


/* 相关产品推荐 */
.rc-related-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.rc-related-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--rc-shadow);
  border: 1px solid var(--rc-gray-border);
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: var(--rc-text-regular);
}

.rc-related-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.rc-related-card h3 {
  color: var(--rc-primary-dark);
}

/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--rc-accent-blue);
  font-weight: 600;
}




/* ============ 底部预约咨询模块 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

/* 响应式 */
@media (max-width: 1100px) {
  .rc-card-grid-6 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .rc-card-grid-3, .rc-card-grid-4, .rc-card-grid-6, .rc-stat-grid, .rc-arch-grid, .rc-related-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .rc-card-grid-3, .rc-card-grid-4, .rc-card-grid-6, .rc-stat-grid, .rc-arch-grid, .rc-related-grid {
    grid-template-columns: 1fr;
  }
  .rc-page h1 { font-size: 32px; }
  .rc-navbar { flex-direction: column; gap: 16px; }
}
</style>
